import React, { useState } from 'react';
import useAsyncEffect from 'use-async-effect';
import { loading } from '../../actions/Loading';
import api from '../../api/api';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { CampaignStatsResult } from '../../model/CampaignStatsResult';
import SortableTable from '../table/SortableTable';
import { FaEye, FaLink } from 'react-icons/fa';
import CampaignStatsSummaryComponent from './CampaignStatsSummaryComponent';
import { IGlobalState } from '../../model/IGlobalState';
import * as Roles from '../../model/Roles';
import { GetFailedBatchSendEventsResult } from '../../model/GetFailedBatchSendEventsResult';
import AnimatedSaveButton from '../AnimatedSaveButton';
import AlertEx from '../AlertEx';
import { CampaignStats } from '../../model/CampaignStats';
import { fromNow } from '../../util/util';

interface IProps{
    combinedTicker:string
    match?: { params: {  campaignId:string }};
}

const Wrapper = styled.div`

.status {
    color:#fff;
    padding:2px 7px;
    border-radius: 5px;
    font-weight: 700;
    display: inline-flex;      /* puts icon + text in a row */
  align-items: center;       /* vertical centering */
  gap: 4px;                  
    
}
.status .icon {
  font-size: 1em;            /* makes icon same size as text */
}
.unopened{
    background-color: #F42525;
}
.unclicked {
    background-color: #F49D25;
}
.delivered {
    background-color: #22C33C;
}
.status-other{
    background-color: #F49D25;
}
.refresh-button-container {
    margin-top: 1rem;
    display: flex;
    flex-direction: row-reverse;
}
.campaign-stats-header{
margin: 1rem 0;
}
.title {
    
    font-weight: 700;
    font-size: 1.2rem;
}
`;

const ColumnEmailAddress = 'Email Address'
const ColumnOpened = 'Opened'
const ColumnClicked = 'Clicked'
const ColumnStatus = 'Status'

const FormatTime = (val:any) => {
    return <span>
                    <span>{fromNow(val)}</span>
                    
                </span>
}

const capitalizeFirst = (str:any)=> {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
}

const headers = [ ColumnEmailAddress, ColumnOpened, ColumnClicked, ColumnStatus ];

const statsCellFormatter = (columnName:string, cell:any, stat:CampaignStats):React.ReactNode => {

    if(columnName ===ColumnEmailAddress ){
        return <span data-referenceid={stat.referenceId} data-toencrypted={stat.toEncrypted} data-nameencrypted={stat.nameEncrypted}>
                 {cell}
                </span>
    }
    else if(columnName ===ColumnOpened ){
        if(cell){
            return FormatTime(cell)
        }else{
            return <span className="status unopened"> <FaEye className="icon"/> Unopened   </span>
        }
    }
    else if(columnName ===ColumnClicked){
        if(cell){
            return FormatTime(cell)
        }else{
            return <span className="status unclicked"> <FaLink className="icon"/> Unclicked</span>
        }
    }
    else if(columnName ===ColumnStatus){
        const cssStatusClass = cell === 'delivered' ? 'delivered' : 'status-other';
        return <span className={`status ${cssStatusClass}`}>{capitalizeFirst(cell)}</span>
    }
    return null;
}

const CampaignStatsComponent: React.FC<IProps>= (props:IProps) => {
    const dispatch = useDispatch();
    const [ item, setItem ] = useState<CampaignStatsResult>();
    const [ failedBatchSendEvents, setFailedBatchSendEvents ] = useState<GetFailedBatchSendEventsResult>();
    const user = useSelector((state: IGlobalState) => state.user);
    const isAdmin = user.roles.hasOwnProperty(Roles.Admin);
    const campaignId = decodeURIComponent(props.match!.params.campaignId);

    useAsyncEffect(async (isMounted:()=>boolean)=> {
        
        refresh(isMounted);
        
      }, []);

      const refresh = async (isMounted:()=>boolean) =>{
            dispatch(loading(true));
        const result = await api().getCampaignStats(campaignId);

        if (isAdmin){
            const failedBatchSendEvents = await api().getFailedBatchSendEvents(campaignId);
            setFailedBatchSendEvents(failedBatchSendEvents);
        }

        if(isMounted()){
            setItem(result)   
        }
        dispatch(loading(false));
        return true;
      }


    const resendFailed = async (id: string) => {
        if (window.confirm('Resend Failed?')) {
            let result = await api().resendFailedBatchSendEvent(id);
            if (result.success) {
                
                AlertEx('Sent!');
            }
            else {
                AlertEx(result.message);                
            }
        }
        return true;

    }

    const getName = (stat:CampaignStats):React.ReactNode => {
        let name = stat.to||'';
        if(stat.name){
            name += ` - ${stat.name}`;
        }
        if(!name){
            console.warn('CampaignStats has no name', stat)
        }
        
        return name;
    }

     const data:any[][] = [];
     let cellFormatter = undefined;
    if(item){
        for(let stat of item.stats){
            let arr:any[] = []

            arr = [
               getName(stat),
               stat.opened || '',
               stat.clicked || '',
               stat.status,
               stat
            ]

            data.push(arr)
        }

        cellFormatter = (columnName:string, cell:any, stat:CampaignStats):React.ReactNode => {
            return statsCellFormatter(columnName, cell, stat);
        }
    }
    

    return <div>

{ item && <Wrapper>
   <div className='campaign-stats-header'>
    <div>
         <span className='title'>Subscriber Activity - </span>
    <span>
{item.subject}
    </span>
    </div>
   
    <div >Created: {fromNow(item.created)}</div>
   </div>
  
    { item.stats.length === 0 && <p className='warning'>Stats being generated...please refresh in a moment</p> }

    
    

    { isAdmin && failedBatchSendEvents && failedBatchSendEvents.events.length > 0 && <table>
        <thead>
            <tr><th>Actions</th><th>Details</th></tr>
        </thead>
        <tbody>
            
            { failedBatchSendEvents.events.map((x,i)=> <tr key={i}>
                <td><AnimatedSaveButton onClick={()=>resendFailed(x.id)} startingText="Resend" progressText="Wait..." completedText="Sent" /></td>
                <td><pre>{JSON.stringify(x, null, 2)}</pre></td>
                
            </tr>)}
        </tbody>

    </table> }

   <CampaignStatsSummaryComponent summary={item.summary}/>

        <div className='refresh-button-container'>
            <AnimatedSaveButton onClick={()=>refresh(()=>true)} startingText="Refresh" progressText="Wait..." completedText="Refreshed" />
        </div>

        

        <SortableTable headers={headers} data={data} cellFormatter={cellFormatter}  />

<p><small>Note: If a subscriber has not opened, but clicked on the email, it's possible that the user blocks the tracking pixel from loading, which is why we don't see the opened time.</small></p>
</Wrapper>}

    </div>
}

export default CampaignStatsComponent